export const LS_KEY = "sat_starred_tp_keys_v2";
